import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import moment from "moment";
import BankBasedTransactionReportFilter from "../../Filters/BankBasedTransactionReportFilter";
import { ColumnHelper } from "util/TableHelper";

import { Table, Empty, Col, Row } from "antd";
import { MenuUnfoldOutlined } from "@ant-design/icons";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../../Filters/Helper";

const DailyBankBasedTransactionReport = (props) => {
  const defaultQueryData = {
    pageSize: 15,
    currencyId: 1,
    currencyCode: "TRY",
    currencySymbol: "₺",
  };
  const [tableData, setTableData] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(queryHelper.getTableDataQueryOptions(defaultQueryData, "d_"));
  const [isDigitReportTransactionFromBank, setIsDigitReportTransactionFromBank] = useState();
  const history = useHistory();

  useEffect(
    () => {
      setFilterValues();
      getTableData();
      RequestHandler.get(`/TenantUserParameter/GetDigitParameter`).then((response) => {
        if (response.success) {
          setIsDigitReportTransactionFromBank(response.data.isDigitReportTransactionFromBank)
        }
      });
    },
    [
      tableDataQueryOptions.bankId,
      tableDataQueryOptions.startDate,
      tableDataQueryOptions.endDate,
      tableDataQueryOptions.currencyId,
      tableDataQueryOptions.transactionTypeGroupId,
    ]
  );

  const getTableData = () => {
    setTableData({
      ...tableData,
      loading: true,
    });

    RequestHandler.post(
      `/Reports/OperationTypeDailyBankBasedTransactionReport`,
      tableDataQueryOptions,
      false
    ).then((response) => {
      setTableData({
        data: response.value,
        total: response.totalCount,
        totalRow: response.totalRow,
        loading: false,
      });
    });

    if (props.onFilterChange) {
      props.onFilterChange(tableDataQueryOptions);
    }
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions,
    };

    filterValues.startDate = typeof (tableDataQueryOptions.startDate) === "string" ? tableDataQueryOptions.startDate : tableDataQueryOptions.startDate?.format("YYYY-MM-DD");
    filterValues.endDate = typeof (tableDataQueryOptions.endDate) === "string" ? tableDataQueryOptions.endDate : tableDataQueryOptions.endDate?.format("YYYY-MM-DD");
    const queryString = queryHelper.getQueryFromValues(filterValues, "d_", true);

    history.replace({
      pathname: window.location.pathname,
      search: queryString
    });
  };

  const paging = (p) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        pageSize: p.pageSize,
      };
    });
  };

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      pageSize: 15,
      currencyId: "1",
      currencyCode: "TRY",
      currencySymbol: "₺",
    });
  };

  const onFinishTableFilter = (query) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        startDate: query.startDate,
        endDate: query.endDate,
        bankId: query.bankId,
        currencyId: query.currencyId,
        currencyCode: query.currencyCode,
        currencySymbol: query.currencySymbol,
        transactionTypeGroupId: query.transactionTypeGroupId,
      };
    });
  };

  const detailTableGroupedByTransactionTypeName = (data) => {
    const columns = [
      {
        title: "İşlem Tipi",
        dataIndex: "transactionTypeName",
      },
      {
        title: "Gelen İşlemler",
        dataIndex: "incomingTransactionsAmount",
        render: (data) => {
          return isDigitReportTransactionFromBank ?
            `${ColumnHelper.renderDecimal(data)} ${tableDataQueryOptions.currencySymbol}`
            :
            `${ColumnHelper.renderDecimal(data).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`
        }
      },
      {
        title: "Gelen İşlem Adet",
        dataIndex: "incomingTransactionsCount",
      },
      {
        title: "Giden İşlemler",
        dataIndex: "outgoingTransactionsAmount",
        render: (data) => {
          return isDigitReportTransactionFromBank ?
            `${ColumnHelper.renderDecimal(data)} ${tableDataQueryOptions.currencySymbol}`
            :
            `${ColumnHelper.renderDecimal(data).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`
        }
      },
      {
        title: "Giden İşlem Adet",
        dataIndex: "outgoingTransactionsCount",
      },
      {
        title: "Gelen-Giden İşlem Farkı",
        dataIndex: "differenceAmount",
        render: (data) => {
          return isDigitReportTransactionFromBank ?
            `${ColumnHelper.renderDecimal(data)} ${tableDataQueryOptions.currencySymbol}`
            :
            `${ColumnHelper.renderDecimal(data).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`
        }
      },
      {
        title: "Detay",
        align: "center",
        render: (row) => {
          const filterQuery = `${odata.dateRange("transactionDateValue", row.date, row.date)} and currencyId eq ${tableDataQueryOptions.currencyId} and transactionTypeId in (${row.transactionTypeIds}) and tenantAccountIsCalculated eq true`;
          const queryString = `transactionDateMin=${moment(row.date).format("YYYY-MM-DD")}&transactionDateMax=${moment(row.date).format("YYYY-MM-DD")}&currencyId=${tableDataQueryOptions.currencyId}&transactionTypeId=${row.transactionTypeName}&filter=${filterQuery}`;
          return (
            <Link
              style={{ fontSize: "150%" }}
              to={`/account-transaction?${queryString}`}
            >
              <MenuUnfoldOutlined />
            </Link>
          );
        }
      },
    ];

    return (
      <Table
        style={{ margin: 5 }}
        columns={columns}
        locale={{
          emptyText: (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" />
          ),
        }}
        expandable={{
          expandedRowRender: (row) =>
            detailTableGroupedByBank(row.details),
        }}
        rowKey={(record) => record.transactionTypeName}
        filterable={true}
        sortable={true}
        pagination={false}
        dataSource={data}
        size="small"
      />
    );
  }


  const detailTableGroupedByBank = (data) => {
    const columns = [
      {
        title: "Banka",
        dataIndex: "bankLogo",
        render: (text) => <img src={text} width={100} />,
      },
      {
        title: "Gelen İşlemler",
        dataIndex: "incomingTransactionsAmount",
        render: (data) => {
          return isDigitReportTransactionFromBank ?
            `${ColumnHelper.renderDecimal(data)} ${tableDataQueryOptions.currencySymbol}`
            :
            `${ColumnHelper.renderDecimal(data).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`
        }
      },
      {
        title: "Gelen İşlem Adet",
        dataIndex: "incomingTransactionsCount",
      },
      {
        title: "Giden İşlemler",
        dataIndex: "outgoingTransactionsAmount",
        render: (data) => {
          return isDigitReportTransactionFromBank ?
            `${ColumnHelper.renderDecimal(data)} ${tableDataQueryOptions.currencySymbol}`
            :
            `${ColumnHelper.renderDecimal(data).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`
        }
      },
      {
        title: "Giden İşlem Adet",
        dataIndex: "outgoingTransactionsCount",
      },
      {
        title: "Gelen-Giden İşlem Farkı",
        dataIndex: "differenceAmount",
        render: (data) => {
          return isDigitReportTransactionFromBank ?
            `${ColumnHelper.renderDecimal(data)} ${tableDataQueryOptions.currencySymbol}`
            :
            `${ColumnHelper.renderDecimal(data).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`
        }
      },
      {
        title: "Detay",
        align: "center",
        render: (row) => {
          const filterQuery = `${odata.dateRange("transactionDateValue", row.date, row.date)} and currencyId eq ${tableDataQueryOptions.currencyId} and bankId eq ${row.bankId} and transactionTypeId in (${row.transactionTypeIds}) and tenantAccountIsCalculated eq true`;
          const queryString = `transactionDateMin=${moment(row.date).format("YYYY-MM-DD")}&transactionDateMax=${moment(row.date).format("YYYY-MM-DD")}&currencyId=${tableDataQueryOptions.currencyId}&bankId=${row.bankId}&transactionTypeId=${row.transactionTypeName}&filter=${filterQuery}`;
          return (
            <Link
              style={{ fontSize: "150%" }}
              to={`/account-transaction?${queryString}`}
            >
              <MenuUnfoldOutlined />
            </Link>
          );
        },
      },
    ];

    return (
      <Table
        style={{ margin: 5 }}
        columns={columns}
        locale={{
          emptyText: (
            <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Veri Yok" />
          ),
        }}
        rowKey={(record) => record.bankId}
        filterable={true}
        sortable={true}
        pagination={false}
        dataSource={data}
        size="small"
      />
    );
  };

  const columns = [
    {
      title: "Tarih",
      dataIndex: "date",
      render: (data, row, index) => moment(data).format("DD.MM.YYYY"),
    },
    {
      title: "Gelen İşlemler",
      dataIndex: "incomingTransactionsAmount",
      render: (data) => {
        return isDigitReportTransactionFromBank ?
          `${ColumnHelper.renderDecimal(data)} ${tableDataQueryOptions.currencySymbol}`
          :
          `${ColumnHelper.renderDecimal(data).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`
      }
    },
    {
      title: "Gelen İşlem Adet",
      dataIndex: "incomingTransactionsCount",
    },
    {
      title: "Giden İşlemler",
      dataIndex: "outgoingTransactionsAmount",
      render: (data) => {
        return isDigitReportTransactionFromBank ?
          `${ColumnHelper.renderDecimal(data)} ${tableDataQueryOptions.currencySymbol}`
          :
          `${ColumnHelper.renderDecimal(data).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`
      }
    },
    {
      title: "Giden İşlem Adet",
      dataIndex: "outgoingTransactionsCount",
    },
    {
      title: "Gelen-Giden İşlem Farkı",
      dataIndex: "differenceAmount",
      render: (data) => {
        return isDigitReportTransactionFromBank ?
          `${ColumnHelper.renderDecimal(data)} ${tableDataQueryOptions.currencySymbol}`
          :
          `${ColumnHelper.renderDecimal(data).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`
      }
    },
    {
      title: "Detay",
      align: "center",
      render: (row) => {
        const filterQuery = `${odata.dateRange("transactionDateValue", row.date, row.date)} and tenantAccountIsCalculated eq true and currencyId eq ${tableDataQueryOptions.currencyId}` +
          (tableDataQueryOptions.bankId ? `and bankId eq ${tableDataQueryOptions.bankId}` : "") + `and tenantAccountIsCalculated eq true`;

        const queryString = `transactionDateMin=${moment(row.date).format("YYYY-MM-DD")}&transactionDateMax=${moment(row.date).format("YYYY-MM-DD")}&currencyId=${tableDataQueryOptions.currencyId}${tableDataQueryOptions.bankId ? "&bankId=" + tableDataQueryOptions.bankId : ""}&filter=${filterQuery}`;
        return (
          <Link
            style={{ fontSize: "150%" }}
            to={`/account-transaction?${queryString}`}
          >
            <MenuUnfoldOutlined />
          </Link>
        );
      },
    }
  ];

  return (
    <>
      <BankBasedTransactionReportFilter
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        data={tableDataQueryOptions}
        style={{ marginTop: 12, marginBottom: 12 }}
        extraText="Varsayılan olarak bugünden itibaren son 30 günlük TRY para birimi listelenmektedir."
        showTransactionTypeFilter={true}
      />

      <Row id="tableArea">
        <Col span={24}>
          <Table
            columns={columns}
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            expandable={{
              expandedRowRender: (row) =>
                detailTableGroupedByTransactionTypeName(row.details),
            }}
            style={{ overflowX: "auto", maxHeight: "100%", width: "100%" }}
            rowKey={(record, index) => index}
            filterable={true}
            sortable={true}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.pageSize,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: tableData.total,
            }}
            dataSource={tableData.data}
            loading={tableData.loading}
            size="small"
            summary={() => {
              if (!tableData.totalRow) return;

              const { incomingTransactionsAmount, incomingTransactionsCount, outgoingTransactionsAmount, outgoingTransactionsCount, differenceAmount } =
                tableData.totalRow;
              return (
                <Table.Summary.Row>
                  <Table.Summary.Cell></Table.Summary.Cell>
                  <Table.Summary.Cell>Toplam:</Table.Summary.Cell>
                  <Table.Summary.Cell>{(isDigitReportTransactionFromBank ? `${ColumnHelper.renderDecimal(incomingTransactionsAmount)} ${tableDataQueryOptions.currencySymbol}`:`${ColumnHelper.renderDecimal(incomingTransactionsAmount).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`)}</Table.Summary.Cell>
                  <Table.Summary.Cell>{incomingTransactionsCount}</Table.Summary.Cell>
                  <Table.Summary.Cell>{(isDigitReportTransactionFromBank ? `${ColumnHelper.renderDecimal(outgoingTransactionsAmount)} ${tableDataQueryOptions.currencySymbol}`:`${ColumnHelper.renderDecimal(outgoingTransactionsAmount).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`)}</Table.Summary.Cell>
                  <Table.Summary.Cell>{outgoingTransactionsCount}</Table.Summary.Cell>
                  <Table.Summary.Cell>{(isDigitReportTransactionFromBank ? `${ColumnHelper.renderDecimal(differenceAmount)} ${tableDataQueryOptions.currencySymbol}`:`${ColumnHelper.renderDecimal(differenceAmount).split(",")[0]} ${tableDataQueryOptions.currencySymbol}`)}</Table.Summary.Cell>
                  <Table.Summary.Cell></Table.Summary.Cell>
                </Table.Summary.Row>
              );
            }}
          />
        </Col>
      </Row>
    </>
  );
};

export default DailyBankBasedTransactionReport;
